import * as React from "react";
import { CopyOverride } from "../api/Config";
declare global {
  interface Window {
    ClientCopyOverride: CopyOverride;
  }
}

enum Club {
  NIF = "NIF",
  NSK = "NSK",
  NGF = "NGF"
}

interface Props {
  onChange: (club: string, team: string) => void;
  initClub?: string;
  initTeam?: string;
}

interface State {
  club?: Club;
  team: string;
}

export default class NykvarnClubSelection extends React.Component<
  Props,
  State
> {
  readonly state: State = {
    club: Club[this.props.initClub],
    team: this.props.initTeam ?? ""
  };

  render() {
    return (
      <div className="form-group">
        <label className="control-label">
          Vill du stötta en speciel förening?
        </label>
        <p className="help-text">
          Klicka på en förening nedan eller låt det vara så fördelas pengarna
          mellan de tre föreningarna.
        </p>
        <div className="team-selection interactive clearfix">
          <div
            className={
              "team" + (this.state.club == Club.NIF ? " team-selected" : "")
            }
            onClick={this.toggleClub.bind(this, Club.NIF)}>
            <img
              src={
                this.state.club == Club.NIF
                  ? "/images/nykvarn/steelers.svg"
                  : "/images/nykvarn/steelers-grey.svg"
              }
            />
            <p className="club-name-full">Nykvarns IF</p>
            <p className="club-name-abbr">NIF</p>
          </div>
          <div
            className={
              "team" + (this.state.club == Club.NSK ? " team-selected" : "")
            }
            onClick={this.toggleClub.bind(this, Club.NSK)}>
            <img
              src={
                this.state.club == Club.NSK
                  ? "/images/nykvarn/nsk.png"
                  : "/images/nykvarn/nsk-grey.png"
              }
            />
            <p className="club-name-full">Nykvarns Sportklubb</p>
            <p className="club-name-abbr">NSK</p>
          </div>
          <div
            className={
              "team" + (this.state.club == Club.NGF ? " team-selected" : "")
            }
            onClick={this.toggleClub.bind(this, Club.NGF)}>
            <img
              src={
                this.state.club == Club.NGF
                  ? "/images/nykvarn/ngf.png"
                  : "/images/nykvarn/ngf-grey.png"
              }
            />
            <p className="club-name-full">Nykvarns Gymnastikförening</p>
            <p className="club-name-abbr">NGF</p>
          </div>
        </div>
        {this.state.club && (
          <>
            <p className="help-text mt-2">
              Om det är något speciellt lag du vill stödja så kan du skriva in
              det här.
            </p>
            <input
              name={"team"}
              value={this.state.team}
              placeholder={"Lagnamn"}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                const team = event.target.value;
                this.setState({ team });
                this.props.onChange(this.state.club, team);
              }}
              className={"form-control"}
            />
          </>
        )}
      </div>
    );
  }

  toggleClub = (club: Club) => {
    console.debug("Toggle team", club);
    if (this.state.club == club) {
      this.setState({ club: null });
      this.props.onChange("", this.state.team);
    } else {
      this.setState({ club });
      this.props.onChange(club, this.state.team);
    }
  };
}
